import { render, staticRenderFns } from "./BookingPopoutNotes.vue?vue&type=template&id=e04ea292&scoped=true&"
import script from "./BookingPopoutNotes.vue?vue&type=script&lang=js&"
export * from "./BookingPopoutNotes.vue?vue&type=script&lang=js&"
import style0 from "./BookingPopoutNotes.vue?vue&type=style&index=0&id=e04ea292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04ea292",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VTextarea})
